export const loadRegisterPage = () => import('./pages/RegisterPage');
